import { DataAttributeDefinitions } from 'scrivito'

import { pisaLeadDataClass } from './Pisa/pisaLeadDataClass'

const attributes: DataAttributeDefinitions = {}

export const Lead = pisaLeadDataClass(attributes)
